var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('ProductZoomer',{attrs:{"base-images":_vm.images,"base-zoomer-options":_vm.zoomerOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }